// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part-list-container {
    width: 95%;
    margin: auto;
}
.part-list-container .modal-content{
    width: 2rem !important;
}

html,
body {
    overflow-x: hidden;
    font-family: 'Nunito';
}

h2 {
    font-size: 20px;
    font-weight: 600;
}

.table {
    overflow-x: scroll;
}

.partlist-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Ensure it appears above other content */
  }
  
  .popup-content {
    background: white;
    width: 58.13vw;
    height:92vh;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    overflow-y: scroll;
  }


table,
td,
th {
    border: 1px solid rgba(0, 0, 0, 0.247);
    border-collapse: collapse;
    padding: .2rem .9rem;
    text-align: start;
    font-size: 14px;
}

.list {
    width: 100%;
}


.list ul li {
    line-height: 24.1.1px !important;
    font-size: 14px;
    font-weight: 400;
    color: #32363F;
}


/* button */
.btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    gap: 1rem;
    margin-top: 2rem;
    width: 100%;
}

button {
    border: none;
}

.btn1 {
    background-color: rgb(18, 112, 18);
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: white;
    width: 14rem;
    height: 2.5rem;
    border-radius: 5px;
}

.btn1 img {
    height: 40px;
    width: 50px;
}

.btn_2 {
    width: 4.5rem;
    height: 2.5rem;
    border-radius: 5px;
    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
    color: white;
}
.btn_ss{
    display: flex;
    justify-content: center;
    gap: 0.4rem;
    padding: 1rem 0rem;
}
.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    color: var(--bs-modal-color);
    pointer-events: auto;
    background-color: var(--bs-modal-bg);
    background-clip: padding-box;
    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    border-radius: var(--bs-modal-border-radius);
    outline: 0;
    
}
.downloads_imgdexcel{
    height: 1.2rem;
  }
  .dexcel{
    background: #5CA170;
    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
    border-radius: 5px;
    border: none;
    border-radius: 5px;
    color: #ffffff;
    font-family: "Nunito";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    padding: 0rem 1.4rem;
    gap: 0.2rem;
    height: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }


.excel-container{
    width: 96%;
    border: 1px solid #AEB4C1;
    margin: 1rem;
}
.excel-container > img{
    width: 96%;
   
}

@media screen and (max-width:480px) {
    .modal-content{
        width: 80% !important;
        margin: auto;
    }
    .popup-content{
        width: 90%;
    }
}`, "",{"version":3,"sources":["webpack://./src/component/PartslistPopup/partslistpopup.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,gCAAgC;IAChE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,0CAA0C;EAC3D;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;EACpB;;;AAGF;;;IAGI,sCAAsC;IACtC,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mEAAmE;IACnE,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;IACpB,oCAAoC;IACpC,4BAA4B;IAC5B,uEAAuE;IACvE,4CAA4C;IAC5C,UAAU;;AAEd;AACA;IACI,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,8CAA8C;IAC9C,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;;AAGF;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,UAAU;;AAEd;;AAEA;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".part-list-container {\n    width: 95%;\n    margin: auto;\n}\n.part-list-container .modal-content{\n    width: 2rem !important;\n}\n\nhtml,\nbody {\n    overflow-x: hidden;\n    font-family: 'Nunito';\n}\n\nh2 {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.table {\n    overflow-x: scroll;\n}\n\n.partlist-popup {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000; /* Ensure it appears above other content */\n  }\n  \n  .popup-content {\n    background: white;\n    width: 58.13vw;\n    height:92vh;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    overflow-y: scroll;\n  }\n\n\ntable,\ntd,\nth {\n    border: 1px solid rgba(0, 0, 0, 0.247);\n    border-collapse: collapse;\n    padding: .2rem .9rem;\n    text-align: start;\n    font-size: 14px;\n}\n\n.list {\n    width: 100%;\n}\n\n\n.list ul li {\n    line-height: 24.1.1px !important;\n    font-size: 14px;\n    font-weight: 400;\n    color: #32363F;\n}\n\n\n/* button */\n.btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    gap: 1rem;\n    margin-top: 2rem;\n    width: 100%;\n}\n\nbutton {\n    border: none;\n}\n\n.btn1 {\n    background-color: rgb(18, 112, 18);\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    color: white;\n    width: 14rem;\n    height: 2.5rem;\n    border-radius: 5px;\n}\n\n.btn1 img {\n    height: 40px;\n    width: 50px;\n}\n\n.btn_2 {\n    width: 4.5rem;\n    height: 2.5rem;\n    border-radius: 5px;\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n    color: white;\n}\n.btn_ss{\n    display: flex;\n    justify-content: center;\n    gap: 0.4rem;\n    padding: 1rem 0rem;\n}\n.modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    color: var(--bs-modal-color);\n    pointer-events: auto;\n    background-color: var(--bs-modal-bg);\n    background-clip: padding-box;\n    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n    border-radius: var(--bs-modal-border-radius);\n    outline: 0;\n    \n}\n.downloads_imgdexcel{\n    height: 1.2rem;\n  }\n  .dexcel{\n    background: #5CA170;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    border: none;\n    border-radius: 5px;\n    color: #ffffff;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 0rem 1.4rem;\n    gap: 0.2rem;\n    height: 2.4rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n\n.excel-container{\n    width: 96%;\n    border: 1px solid #AEB4C1;\n    margin: 1rem;\n}\n.excel-container > img{\n    width: 96%;\n   \n}\n\n@media screen and (max-width:480px) {\n    .modal-content{\n        width: 80% !important;\n        margin: auto;\n    }\n    .popup-content{\n        width: 90%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
